import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { setCrossMatchedOptions } from '../store/options.actions'

export function* getCrossMatchedOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getTherapeuticHypothermiaOptions])
    const { entity } = response
    yield put(setCrossMatchedOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getCrossMatchedOptions() error: ${e}`))
  }
}
export function* getCrossMatchedOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getCrossMatchedOptions)
}
